/* global femcare */

femcare.navigation.anchor = {

    /**
     * Initialize anchor navigation
     */
    init() {
        const $selectAnchor = $('.sticky-anchor--select');
        const $listAnchor = $('.sticky-anchor--list');
        this.anchorables = $('[data-anchor-index]').toArray();

        if ($selectAnchor.length && this.anchorables.length) {
            femcare.shared.customDropdown.create($selectAnchor[0]);
            $selectAnchor.append('<div class="sticky-anchor__underline"></div>');
            this.initAnchor($selectAnchor, ($anchor, $activeOption) => {
                femcare.shared.customDropdown.setOption($activeOption[0]);
            });
        }

        if ($listAnchor.length && this.anchorables.length) {
            const activeListItemClass = 'active';
            this.initAnchor($listAnchor, ($anchor, $activeOption) => {
                $anchor.find('[data-value]')
                    .removeClass(activeListItemClass)
                    .removeAttr('aria-current');

                $activeOption
                    .addClass(activeListItemClass)
                    .attr('aria-current', 'true');
            });
        }
    },

    /**
     * Initialize individual anchor
     * @param {jQuery} $anchor - The anchor element
     * @param {Function} setActive - Function to set the active state of the anchor
     */
    initAnchor($anchor, setActive) {
        this.anchorables.forEach((anchorable, i) => {
            const observer = new IntersectionObserver(([entry]) => {
                if (entry.isIntersecting) {
                    const anchorTarget = anchorable.getAttribute('data-anchor-index');
                    const $activeElement = $anchor.find(`[data-value=${anchorTarget}]`);

                    if ($activeElement.length) {
                        setActive($anchor, $activeElement);
                        $anchor.find('.select-selected').click();
                    }
                }
            }, {
                rootMargin: '-50% 0px'
            });

            observer.observe(anchorable);
        });

        const animationDuration = 1000;
        $anchor.find('[data-value]').on('click', (e) => {
            const $target = $(`[data-anchor-index=${e.currentTarget.getAttribute('data-value')}]`);
            if(!$target.length) {
                console.warn(`Anchor menu item "${$(e.currentTarget).text().trim()}" exists in the menu, but the corresponding section is missing on the page.`);
                return;
            }
            const position = $target.position();
            const offset = parseInt($anchor.css('top'), 10) + parseInt($anchor.css('height'), 10);
            const targetY = position.top - offset;

            $('html, body').animate({ scrollTop: targetY }, animationDuration);

            $target.attr('tabindex', '-1');
            $target.trigger('focus');
        });
    }
};
